import {registerBlockType} from "@wordpress/blocks"
import { RichText, InspectorControls,  BlockControls,  AlignmentToolbar, FontSizePicker, PanelColorSettings, useBlockProps
, __experimentalLinkControl as LinkControl} from '@wordpress/block-editor';
import { PanelBody, Button, RangeControl, ToggleControl, SelectControl, TextControl, TabPanel, __experimentalBoxControl as BoxControl, __experimentalBorderBoxControl as BorderBoxControl, ToolbarButton, Popover, __experimentalUnitControl as UnitControl, BaseControl} from '@wordpress/components';
const { Fragment, useState, useRef } = wp.element;
const { __ } = wp.i18n;
import FontPicker from "./lib/FontPicker.js";
import classnames from 'classnames';
import { displayShortcut } from '@wordpress/keycodes';
import { link, linkOff } from '@wordpress/icons';
import {colors} from './lib/colors';

const BlockEdit = (props) => {
	
	const { attributes, setAttributes, clientId,
		className,
		isSelected,
		onReplace,
		mergeBlocks, } = props;
	const { linkTarget, placeholder, rel, style, text, url, width } =
		attributes;

	setAttributes({ uniqueid: 'spiceblocksbutton' +clientId.slice(0,8) });
	const{ uniqueid, title, buttontype, titleColor, bgColor, titlehColor, bghColor, shadowColor, border, borderradius, margins, buttonpaddings, fontfamily, titlefontSize, TitleLineHeight, TitleFontWeight, TitleTransform, TitleDecoration, TitleLetterSpacing, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, bordertopradius, borderrightradius, borderbottomradius, borderleftradius }=attributes;	
	const blockclass='spice-blocks-button-wrapper';
	const buttonclass='spice-blocks-button';
	const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
	const animationclass='animated '+attributes.durations+' '+attributes.animation;
	const displaydesktop=(hidedesktop != false) ? 'hide-desktop' : '';
	const displaytablet=(hidetablet != false) ? 'hide-tablet' : '';
	const displaymobile=(hidemobile != false) ? 'hide-mobile' : '';
	const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
	const NEW_TAB_REL = 'noreferrer noopener';    

	function setTitle(value) {
		setAttributes({title:value});
	}
	function setTitleColor(value) {
		setAttributes({titleColor:value});
	}
	function setBgColor(value) {
		setAttributes({bgColor:value});
	}
	function setShadowColor(value) {
		setAttributes({shadowColor:value});
	}
	function setTitlehColor(value) {
		setAttributes({titlehColor:value});
	}
	function setBghColor(value) {
		setAttributes({bghColor:value});
	}
	function unlink() {
		setAttributes( {
			url: undefined,
			linkTarget: undefined,
			rel: undefined,
		} );
		setIsEditingURL( false );
	}

	function startEditing( event ) {
		event.preventDefault();
		setIsEditingURL( true );
	}

	function onToggleOpenInNewTab( value ) {
		const newLinkTarget = value ? '_blank' : undefined;

		let updatedRel = rel;
		if ( newLinkTarget && ! rel ) {
			updatedRel = NEW_TAB_REL;
		} else if ( ! newLinkTarget && rel === NEW_TAB_REL ) {
			updatedRel = undefined;
		}

		setAttributes( {
			linkTarget: newLinkTarget,
			rel: updatedRel,
		} );
	}
	const blockProps = useBlockProps();

	const SpiceColorTabPanel = () => (
		<TabPanel
			className="color-tab-panel"
			activeClass="active-tab"
			tabs={[
				{
					name: 'normal',
					title: __('Normal','spice-blocks'),
					className: 'tab-one',
					content:<PanelColorSettings  initialOpen={open}
						
						colorSettings={[
							{
								value: titleColor,
								clearable: true,
								onChange: setTitleColor,
								label: __('Text Color:','spice-blocks')
							},
							{
								value: bgColor,
								clearable: true,
								onChange: setBgColor,
								label: __('Background Color:','spice-blocks')
							},
						]}
						className={'spice-blocks-normal-button'}
					/>
				},
				{
					name: 'hover',
					title: __('Hover','spice-blocks'),
					className: 'tab-two',
					content:<PanelColorSettings  initialOpen={open}
						
						colorSettings={[
							{
								value: titlehColor,
								clearable: true,
								onChange: setTitlehColor,
								label: __('Text Color:','spice-blocks')
							},
							{
								value: bghColor,
								clearable: true,
								onChange: setBghColor,
								label: __('Background Color:','spice-blocks')
							},
						]}
						className={'spice-blocks-hover-button'}
					/>
				},
			]}
		>
		{ ( tab ) => <p>{ tab.content }</p> }
		</TabPanel>
	);

	if(fontfamily !=null){
		let urlf = 'https://fonts.googleapis.com/css2?family='+fontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
         let link = document.createElement('link')
          link.href = urlf;
          link.rel = "stylesheet";
          link.type =  "text/css";
          
          if ( jQuery("body").hasClass("site-editor-php") ) { 
          jQuery('iframe').contents().find("head").append(link);
      }else{
      	document.head.appendChild(link);
      }
    }  
    const [ popoverAnchor, setPopoverAnchor ] = useState( null );

	const ref = useRef();
	const richTextRef = useRef();

	const isURLSet = !! url;
	const opensInNewTab = linkTarget === '_blank';
	const [ isEditingURL, setIsEditingURL ] = useState( false );

	const bordertop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
	const borderright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
	const borderbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
	const borderleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;
	
	return(
		<Fragment>
			<style dangerouslySetInnerHTML={{
			  __html: [
			     `.spice-blocks-button-wrapper#${uniqueid} .wp-block-spice-blocks-spice-button{
						color: ${titleColor};
						background-color:${bgColor};
						border: ${border.width} ${border.style} ${border.color};
						border-top:${bordertop};
						border-right:${borderright};
						border-bottom:${borderbottom};
						border-left:${borderleft};
						border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};
						padding: ${buttonpaddings.top} ${buttonpaddings.right} ${buttonpaddings.bottom} ${buttonpaddings.left};	
						font-size: ${titlefontSize};
						font-weight: ${TitleFontWeight};
						line-height: ${TitleLineHeight}px;
						animation-delay: ${delay}ms;
						box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
						font-family:${fontfamily};
						text-transform:${TitleTransform};
						text-decoration:${TitleDecoration};
						letter-spacing:${TitleLetterSpacing}px;
					}
					.spice-blocks-button-wrapper#${uniqueid} .wp-block-spice-blocks-spice-button:hover{
						color: ${titlehColor};
						background-color:${bghColor};
					}
					.spice-blocks-button-wrapper#${uniqueid}{
						margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
						animation-delay: ${delay}ms;		

					}`					
			    ].join('\n')
			  }}>
			</style>
			<InspectorControls>
				<PanelBody initialOpen={false} title={__('General Settings','spice-blocks')}>
					<SelectControl
			            label={__('Type','spice-blocks')}
			            value={ buttontype }
			            options={ [
			                { label: __('Link','spice-blocks'), value: 'link' },
			                { label: __('Submit','spice-blocks'), value: 'submit' },
			            ] }
			            onChange={ (newtext) => setAttributes({ buttontype: newtext }) }					  
			        />			        
					<BoxControl 
						label={__('Margin','spice-blocks')}
						inputProps={{ min: -300 }}
						values={margins}
						sides={['top', 'bottom','left','right']}
						allowReset={false}
						units={[]}
						onChange={(newValue) =>
							setAttributes({
								...margins,
								margins: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>
					<BoxControl
						values={buttonpaddings}
						label={__('Button Padding','spice-blocks')}						
						units={[]}
						allowReset={false}
						onChange={(newValue) =>
							setAttributes({
								...buttonpaddings,
								buttonpaddings: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>
          			<BorderBoxControl
						colors={ colors }
			            label={ __( 'Border' ,'spice-blocks') }
			            onChange={(newtext) => setAttributes({ border: newtext })}
			            value={ border }
			        />

					<BaseControl className="spice-blocks-border-radius" label={__('Border Radius','spice-blocks')} __nextHasNoMarginBottom={ true }>
				        <UnitControl className={"border-radius-top"} onChange={ (newtext) => setAttributes({ bordertopradius: newtext }) } value={ bordertopradius } placeholder={"Top"} />

				        <UnitControl className={"border-radius-right"} onChange={ (newtext) => setAttributes({ borderrightradius: newtext }) } value={ borderrightradius } placeholder={"right"} />			        
				        
				        <UnitControl className={"border-radius-left"} onChange={ (newtext) => setAttributes({ borderleftradius: newtext }) } value={ borderleftradius } placeholder={"left"}/>

				        <UnitControl className={"border-radius-bottom"}  onChange={ (newtext) => setAttributes({ borderbottomradius: newtext }) } value={ borderbottomradius }  placeholder={"bottom"}/>	       
			        </BaseControl>
					
					<PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit'}>					
						<ToggleControl
							label={__('Hide on Desktop','spice-blocks')}
							checked={hidedesktop}
							onChange={(newval) => setAttributes({ hidedesktop: newval })}
						/>
						<ToggleControl
							label={__('Hide on Tablet','spice-blocks')}
							checked={hidetablet}
							onChange={(newval) => setAttributes({ hidetablet: newval })}
						/>
						<ToggleControl
							label={__('Hide on Mobile','spice-blocks')}
							checked={hidemobile}
							onChange={(newval) => setAttributes({ hidemobile: newval })}
						/>
					</PanelBody>

					<PanelBody initialOpen={false} title={__('Animation Effects','spice-blocks')} className={'spice-panel-edit'}>
		        		<SelectControl
				            label={__('Animation','spice-blocks')}
				            value={ animation }
				            options={ [
				            	{ label: __('None','spice-blocks'), value: ' ' },
                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' },
			            	] }
		            		onChange={ (newtext) => setAttributes({ animation: newtext }) }					  
		        		/>  
		        		{ animation != '' && (
				        	<>
						        <SelectControl
						            label={__('Durations','spice-blocks')}
						            value={ durations }
						            options={ [
						            	{ label: __('Normal','spice-blocks'), value: ' ' },
						                { label: __('Slow','spice-blocks'), value: 'slow' },
						                { label: __('Fast','spice-blocks'), value: 'fast' },
						            ] }
						            onChange={ (newtext) => setAttributes({ durations: newtext }) }					  
						        />  
					        	<TextControl
						            label={__('Delay(ms)','spice-blocks')}			    
						            value={delay}
			        				onChange={(newtext) => setAttributes({ delay: newtext })}
							    />
							</>
							)
						}
					</PanelBody>
				</PanelBody>

				<PanelBody initialOpen={false} title={ __('Box Shadow','spice-blocks') }>	
					<RangeControl 
						label={ __('Horizontal Shadow(px)','spice-blocks') }			    
					    value={ hshadow}
					    onChange={(newtext) => setAttributes({ hshadow: newtext })}
						min={0}
						max={100}
					/>
					<RangeControl 
						label={ __('Vertical Shadow(px)','spice-blocks') }			    
					    value={ vshadow}
			        	onChange={(newtext) => setAttributes({ vshadow: newtext })}
						min={0}
						max={100}
					/>	
					<RangeControl 
						label={ __('Blur Shadow(px)','spice-blocks') }			    
					    value={ blurshadow}
			        	onChange={(newtext) => setAttributes({ blurshadow: newtext })}
						min={0}
						max={100}
					/>
					<PanelColorSettings  initialOpen={true}
						className='spice-block-section-bg-color'
						title={ __('Box Shadow Color','spice-blocks') }
						colorSettings={[
							{
							value: shadowColor,
							onChange: setShadowColor,
							label: __('Box Shadow:','spice-blocks')
							},
						]}
					/>
				</PanelBody>

				<PanelBody initialOpen={false} title={__('Color & Background Settings','spice-blocks')} className={"spice-blocks-dual-color"} >
			    	<div {...blockProps} >
						{SpiceColorTabPanel()}
					</div>				   
				</PanelBody>
				
				<PanelBody initialOpen={false} title={__('Typography Settings','spice-blocks')} className={"spiceheadingtypo"} >
					<BaseControl id="spice-blocks-font-family" label={__(' Font Family','spice-blocks')} __nextHasNoMarginBottom={ true }>
						<FontPicker
		                    apiKey="AIzaSyBH0F5UCzRyGQImf8sDK3UVo18kCeq_FqM"
		                    activeFontFamily={ fontfamily }
		                    limit={ 200 }
		                    onChange={ ( nextFont ) => setAttributes({
		                        fontfamily: nextFont.family
		                    }) }
		            	/>
					</BaseControl>
					
			        <FontSizePicker 
			       		 __nextHasNoMarginBottom
			            value={ titlefontSize }
			            onChange={(userVal) => setAttributes({
									titlefontSize: userVal
								})}
			            allowReset={false}
			        />
			        <SelectControl
			            label={__('Font Weight','spice-blocks')}
			            value={ TitleFontWeight }
			            options={ [
			                { label: __('Thin','spice-blocks'), value: '100' },
			                { label: __('Extra Light','spice-blocks'), value: '200' },
			                { label: __('Light','spice-blocks'), value: '300' },
			                { label: __('Regular','spice-blocks'), value: '400' },
			                { label: __('Medium','spice-blocks'), value: '500' },
			                { label: __('Semi Bold','spice-blocks'), value: '600' },
			                { label: __('Bold','spice-blocks'), value: '700' },
			                { label: __('Extra Bold','spice-blocks'), value: '800' },
			                { label: __('Black','spice-blocks'), value: '900' },
			            ] }
			            onChange={ (newtext) => setAttributes({ TitleFontWeight: newtext }) }					  
			        />
			        <RangeControl 
						label={__('line Height(px)','spice-blocks')}			    
					    value={ TitleLineHeight}
			        	onChange={(newtext) => setAttributes({ TitleLineHeight: newtext })}
						min={0}
						step={0.1}
						max={100}
					/>
					<SelectControl
			            label={__('Transform','spice-blocks')}
			            value={ TitleTransform }
			            options={ [
			                { label: __('Default','spice-blocks'), value: '' },
			                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
			                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
			                { label: __('Capitalize','spice-blocks'), value: 'capitalize' },
			            ] }
			            onChange={ (newtext) => setAttributes({ TitleTransform: newtext }) }					  
		        	/>

			        <SelectControl
			            label={__('Decoration ','spice-blocks')}
			            value={ TitleDecoration }
			            options={ [
			                { label: __('Default','spice-blocks'), value: '' },
			                { label: __('Underline','spice-blocks'), value: 'underline' },
			                { label: __('Overline','spice-blocks'), value: 'overline' },
			                { label: __('Line Through','spice-blocks'), value: 'line-through' },
			            ] }
			            onChange={ (newtext) => setAttributes({ TitleDecoration: newtext }) }					  
			        />

			        <RangeControl 
						label={__('Letter Spacing','spice-blocks')}			    
					    value={ TitleLetterSpacing}
			        	onChange={(newtext) => setAttributes({ TitleLetterSpacing: newtext })}
						min={-10.0}
						step={0.1}
						max={10.0}
					/>
		        </PanelBody> 				

			</InspectorControls>

		<BlockControls>
			<AlignmentToolbar
				value={attributes.textAlignment}
				onChange={(newalign) => setAttributes({ textAlignment: newalign })}
			/>			
		</BlockControls>

		<div className={`${blockclass} ${alignmentClass} ${animationclass} ${displayclass}`} id={uniqueid}>
			{buttontype == 'link' && 
				<a className={buttonclass}> 
					<RichText
						ref={ richTextRef }
						tagName={"span"}
						aria-label={ __( 'Button text' ) }
						placeholder={ placeholder || __( 'Add text…','spice-blocks' ) }
						value={ title }
						onChange={ (newtext) => setAttributes({ title: newtext })}
						withoutInteractiveFormatting
						className={ classnames(
							className,
							'wp-block-button__link',
							
						) }			
					/>
				</a>
			}
			{buttontype == 'submit' && 
				<button className={`${buttonclass} ${alignmentClass}`}> 
					<RichText
						ref={ richTextRef }
						tagName={"span"}
						aria-label={ __( 'Button text' ) }
						placeholder={ placeholder || __( 'Add text…','spice-blocks' ) }
						value={ title }
						onChange={ (newtext) => setAttributes({ title: newtext })}
						withoutInteractiveFormatting
						className={ classnames(
							className,
							'wp-block-button__link',
							
						) }			
					/>
				</button>
			}
		</div>
		{ buttontype == 'link' &&
			<BlockControls group="block">
				{ ! isURLSet && (
					<ToolbarButton
						name="link"
						icon={ link }
						title={ __( 'Link' ) }
						shortcut={ displayShortcut.primary( 'k' ) }
						onClick={ startEditing }
					/>
				) }
				{ isURLSet && (
					<ToolbarButton
						name="link"
						icon={ linkOff }
						title={ __( 'Unlink' ) }
						shortcut={ displayShortcut.primaryShift( 'k' ) }
						onClick={ unlink }
						isActive={ true }
					/>
				) }
			</BlockControls>
		}
		{ isSelected && ( isEditingURL || isURLSet ) && (
			<Popover
				position="bottom center"
				onClose={ () => {
					setIsEditingURL( false );
					richTextRef.current?.focus();
				} }
				anchor={ popoverAnchor }
				focusOnMount={ isEditingURL ? 'firstElement' : false }
				__unstableSlotName={ '__unstable-block-tools-after' }
				shift
			>
				<LinkControl
					className="wp-block-navigation-link__inline-link-input"
					value={ { url, opensInNewTab } }
					onChange={ ( {
						url: newURL = '',
						opensInNewTab: newOpensInNewTab,
					} ) => {
						setAttributes( { url: newURL } );

						if ( opensInNewTab !== newOpensInNewTab ) {
							onToggleOpenInNewTab( newOpensInNewTab );
						}
					} }
					onRemove={ () => {
						unlink();
						richTextRef.current?.focus();
					} }
					forceIsEditingLink={ isEditingURL }
				/>
			</Popover>
		) }
	</Fragment>
	);
};
 

registerBlockType('spice-blocks/spice-button',{

	title:__('Button','spice-blocks'),
	icon: <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><g id="Layer_1"><g stroke="null" id="svg_14"><rect stroke="#09A223" rx="4" id="svg_2" height="12.4121" width="20.66935" y="9.14495" x="2" stroke-width="2" fill="#fff"></rect><line stroke="#09A223" id="svg_5" y2="15" x2="18" y1="15" x1="7" stroke-width="2" fill="none"></line></g></g></svg>,
	category:'spice-blocks',
	example: {
        'attributes' : {
            'mode' : 'preview',
        }
    },
	keywords:['Spice Button','Button','Link'],
	attributes:{
		uniqueid:{
			type:'string'
		},
		url: {
			"type": "string",
			"source": "attribute",
			"selector": "a",
			"attribute": "href"
		},
		linkTarget: {
			"type": "string",
			"source": "attribute",
			"selector": "a",
			"attribute": "target"
		},
		rel: {
			type: "string",
			source: "attribute",
			selector: "a",
			attribute: "rel"
		},
		placeholder: {
			type: "string"
		},
		title:{
			type:'string',
		},
		buttontype:{
			type:'string',
			default:'link'
		},
		textAlignment: {
			type: 'string',
			default:'left'
		},		
		titleColor:{
			type:'string',
			default:'#fff'
		},
		bgColor:{
	    	type:'string',
	    	default:'#4CAF50'
	    },
	    titlehColor:{
			type:'string',
		},
		bghColor:{
	    	type:'string',
	    	default:'#0693e3'
	    },
	    shadowColor:{
	    	type:'string',
	    	default:'#000'
	    },
	    border: {
            type: 'object',
            default: {
                color: '',
                style: '',
                width: '',        
            },
        },
        bordertopradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    borderrightradius:{
	    	type: 'string', 
	    	default: '0px' 
	    },
	    borderbottomradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    borderleftradius:{
	    	type: 'string',
	    	default: '0px'
	    },
		margins: {
	        default: {
	            top: '0px',
	            left: '0px',
	            right: '0px',
	            bottom: '0px'
	        }
    	},
		buttonpaddings:{
			type: 'object',
		    default: {
		        top: '',
		        left: '',
		        bottom: '',
		        right: '',
		        
		      },
		},
    	hshadow: {
			type: 'number',
			default: 0
		},
		vshadow: {
			type: 'number',
			default: 0
		},
		blurshadow: {
			type: 'number',
			default: 0
		},
		TitleFontWeight:{
			type:'string',
			default:'600'
		},
    	TitleLineHeight:{
	    	type:'number',
	    	default:15
	    },
	    hidedesktop:{
	    	type: 'boolean',
				default: false
	    },
	    hidetablet:{
	    	type: 'boolean',
				default: false
	    },
	    hidemobile:{
	    	type: 'boolean',
				default: false
	    },
	    animation:{
	    	type:'string',
	    	default:''
	    },
	    durations:{
	    	type:'string',
	    	default:' '
	    },
	    delay:{
	    	type:'string',
	    }, 
	    fontfamily:{
	    	type:'string',
	    	default:'Open Sans',
	    },
	    titlefontSize:{
	    	type:'string',
	    },
	    TitleTransform:{
	    	type:'string'
	    },
	    TitleDecoration:{
	    	type:'string'
	    },
	    TitleLetterSpacing:{
	    	type:'number'
	    },
	},

	edit:BlockEdit,

	save:(props)=>{
		const { attributes } = props;
		const{uniqueid, fontfamily, title, buttontype, titleColor, bgColor, titlehColor, bghColor, shadowColor, border, borderradius, margins, buttonpaddings, titlefontSize, TitleLineHeight, TitleFontWeight, TitleTransform, TitleDecoration, TitleLetterSpacing, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, bordertopradius, borderrightradius, borderbottomradius, borderleftradius}=attributes;
		const { linkTarget, placeholder, rel, style, text, url, width } =
		attributes;
		const blockclass='spice-blocks-button-wrapper';
		const buttonclass='spice-blocks-button';
		const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
		const animationclass='animated '+attributes.durations+' '+attributes.animation;
		const displaydesktop=(hidedesktop != false) ? 'hide-desktop' : '';
		const displaytablet=(hidetablet != false) ? 'hide-tablet' : '';
		const displaymobile=(hidemobile != false) ? 'hide-mobile' : '';
		const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
		
		const buttonClasses = classnames(
			'wp-block-spice-blocks-spice-button'
		);

		const bordertop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
		const borderright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
		const borderbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
		const borderleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;
		
		return(
			<>	
				<style dangerouslySetInnerHTML={{
				  __html: [
				     `.spice-blocks-button-wrapper#${uniqueid} .wp-block-spice-blocks-spice-button{
							color: ${titleColor};
							background-color:${bgColor};							
							border: ${border.width} ${border.style} ${border.color};
							border-top:${bordertop};
							border-right:${borderright};
							border-bottom:${borderbottom};
							border-left:${borderleft};
							border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};
							padding: ${buttonpaddings.top} ${buttonpaddings.right} ${buttonpaddings.bottom} ${buttonpaddings.left};	
							font-size: ${titlefontSize};
							font-weight: ${TitleFontWeight};
							line-height: ${TitleLineHeight}px;							
							box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
							font-family:${fontfamily};
							text-transform:${TitleTransform};
							text-decoration:${TitleDecoration};
							letter-spacing:${TitleLetterSpacing}px;
						}
						
						.spice-blocks-button-wrapper#${uniqueid} .wp-block-spice-blocks-spice-button:hover{
							color: ${titlehColor};
							background-color:${bghColor};
						}
						.spice-blocks-button-wrapper#${uniqueid}{
							margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
							animation-delay: ${delay}ms;
						}`					
				    ].join('\n')
				  }}>
				</style>
				<script> 
					var fontfamily2=`{fontfamily}`;
					var url2 = 'https://fonts.googleapis.com/css2?family='+fontfamily2+':wght@100;200;300;400;500;600;700;800;900&display=swap';
					var link2 = document.createElement('link');
					link2.href = url2;
					link2.rel = "stylesheet";
					link2.type =  "text/css";	          
					document.head.appendChild(link2);
				</script>
				<div className={`${blockclass} ${alignmentClass} ${animationclass} ${displayclass} ${props.attributes.className}`} id={uniqueid}>
					{buttontype == 'link' && 
						<a className={buttonclass} href={ url } target={ linkTarget } rel={ rel }>
							<RichText.Content
								tagName={"span"}
								className={ buttonClasses }
								title={ title }
								value={ title }
							/>
						</a>
					}
					{buttontype == 'submit' && 
						<button className={`${buttonclass} ${alignmentClass}`}>
							<RichText.Content
								tagName={"span"}
								className={ buttonClasses }
								title={ title }
								value={ title }	
							/>
						</button>
					}
				</div>

			</>
		)
	}
})